import React from 'react';
import './Loaders.css';

const ImageUploadLoader = ({ messages = ['Processing...'], activeIndex = 0 }) => {
  return (
    <div className="image-upload-loader">
      <div className="skeleton-loader-container">
        {/* Skeleton Card */}
        <div className="skeleton-card">
          <div className="skeleton-shimmer-overlay">
            <div className="shimmer-wave"></div>
          </div>
        </div>

        {/* Loading Message */}
        <div className="skeleton-message">
          <div className="loader-spinner-small"></div>
          <span>{messages[activeIndex] || 'Processing...'}</span>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadLoader;
